import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SnackService } from '@shared/services';
import { ISnackItem } from '@shared/interfaces/various/ISnackItem';
import { Subscription } from 'rxjs';
import { SnackType } from '@shared/enums';

@Component({
    selector: 'app-snacks',
    templateUrl: './snacks.component.html',
    styleUrls: ['./snacks.component.scss'],
    standalone: false
})
export class SnacksComponent implements OnInit {
    snacks: ISnackItem[] = [];
    subscription: Subscription;

    constructor(
        private snackService: SnackService,
        private changeDetector: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.subscription = this.snackService.newSnackItem.subscribe(e => {
            if (e) {
                if (e.type === SnackType.ProgressBar) {
                    const existingItem = this.snacks.find(a => e.id === a.id);
                    if (existingItem) {
                        existingItem.progress = e.progress;
                        this.changeDetector.detectChanges();

                        if (existingItem.progress === 100 || e.failed) {
                            setTimeout(() => this.closeItem(existingItem), 2000);
                        }
                    } else {
                        this.snacks.push(e);
                    }
                } else {
                    this.snacks.push(e);
                }
            }
        });
    }

    closeItem(item: ISnackItem) {
        this.snacks = this.snacks.filter(e => e !== item);
    }
}
